module.exports = "/_next/static/resources/box-cccc618af1b233f69158c1c2db0004bc.webp";